export default () => {
  $(document).on('click', '[data-cart-wishlist-items] [data-remove-wishlist-item]', (e) => {
    if (!window._swat) {
      return;
    }

    const remove_id = $(e.currentTarget).closest('[data-cart-wishlist-item]').data('cart-wishlist-item-id');
    const remove_object = _.find(window.wishlist_products, { id: remove_id });

    if (typeof remove_object === 'undefined') {
      return;
    }

    window._swat.removeFromWishList({
      epi: remove_object.epi,
      du: remove_object.du,
      empi: remove_object.empi,
      iu: remove_object.iu,
    }, () => {
      // Successfully deleted, re-render page
      window.location.reload(false);
    });
  });
};
